import { jsx as n } from "react/jsx-runtime";
import { _ as t } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index44.css';const l = "_page-container_1cfro_1", p = "_content_1cfro_2", e = {
  pageContainer: l,
  content: p
};
function g(o) {
  const {
    className: a,
    contentClassName: c,
    children: s,
    contentAs: r = "div",
    containerAs: i = "div"
  } = o, m = r;
  return /* @__PURE__ */ n(i, { className: t(e.pageContainer, a), children: /* @__PURE__ */ n(m, { className: t(e.content, c), children: s }) });
}
export {
  g as default
};
